<template>
  <div class="container">
    <b-row>
      <b-container>
        <h2 class="text-center py-2">
          {{labels.title}}
        </h2>
      </b-container>
    </b-row>
    <b-row v-if="!isLoading">
      <div class="col-md-12 d-flex justify-content-end">
        <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="goToCreateUser()">
          <md-icon>add</md-icon>
        </md-button>
      </div>
      <div class="row col-md-12 justify-content-center mt-2">
        <b-table
          :items="users"
          :fields="fields"
          hover
          bordered
          responsive
          sticky-header="500px"
          small
          class="tblEstandar"
          head-variant="custom-blue"
          :per-page="perPage"
          :current-page="currentPage"
        >
          <template #cell(id_rol)="data">
            <div class="text-left">{{ nombreRol(data.item.id_rol) }}</div>
          </template>
          <template #cell(acciones)="data">
            <md-button
              style="background-color: #e5ac00; width: 30px; height: 30px;"
              class="md-fab md-primary"
              @click="editUser(data.item.id)"
            >
              <md-icon>edit</md-icon>
            </md-button>
          </template>
          <template #cell(accionInac)="data">
            <md-button v-if="data.item.state == 1"
              style="background-color: #4eff44; width: 30px; height: 30px;"
              class="md-fab md-primary"
              @click="inactivaUser(data.item.id)"
            >
              <md-icon>check</md-icon>
            </md-button>
            <md-button v-else
              style="background-color: #cd2838; width: 30px; height: 30px;"
              class="md-fab md-primary"
              @click="activarUser(data.item.id)"
            >
              <md-icon>close</md-icon>              
            </md-button>
          </template>
        </b-table>
        <div class="row col-12 mt-1">
          <div class="col-10 d-flex justify-content-center">
            <b-pagination
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="users.length"
              align="center"
              size="md"
              class="custom-pagination"
            ></b-pagination>
          </div>
          <div class="col-2 d-flex justify-content-end">
            <label class="mr-2 mb-0">Filas por página:</label>
            <b-form-select
            v-model="perPage"
            :options="[5, 10, 20, 50, 100, 500]"
            size="sm"
            style="width: 80px;"
            ></b-form-select>
          </div>
        </div>
      </div>
    </b-row>
    <b-row v-else>
      <b-col md="12" lg="12" class="p-4 mx-audo">
        <div class="text-center">
          <b-spinner></b-spinner>
        </div>
      </b-col>
    </b-row>
    <InfoUser :modInfoUser="showInfoUser" :dataRole="roles" :dataUser="inforUser" @cierraModal="cierraModal"/>
    <EditarUser :showDialogEdit="showDialogEdit" :formEdit="formEdit" @cierraModal="cierraModal"></EditarUser>
    <InacticaItem :InactivaItem="inactivateUser" @confirmDelete="confirmInactivate" @cierraModal="cierraModal"/>
  </div>
</template>

<script>
import User from "@/services/User";
import Rol from "@/services/Roles";
import InfoUser from "./InfoUser.vue";
import EditarUser from "./EditarUser.vue";
import InacticaItem from "../utils/InacticaItem.vue";

export default {
  name: "ListUsers",
  components: {InfoUser,EditarUser,InacticaItem},

  data: () => ({
    rolSeleccionado: {},//<-- el seleccionado estará aquí
    myOptions: [],
    nameUser: '',
    identificacionUser: '',
    telefonoUser: '',
    correo: '',
    rolSelected: '',
    currentSort: "createdAt",
    currentSortOrder: "asc",
    showDialog: false,
    showDialogEdit: false,
    dialogItem: {},
    users: [],
    roles: [],
    searched: [],
    search: null,
    isEmpty: false,
    isUpdating: false,
    isLoading: false,
    success: false,
    error: false,
    elementosPorPagina:10,
    datosPaginados: [],
    paginaActual: 1,
    searchUser: null,
    searchEmail: null,
    showInfoUser: false,
    inactivateUser: false,
    idUserInactivar: "",
    inforUser: [],
    formEdit: {
      nameUser: '',
      cedula: '',
      identificacionUser: '',
      phone: '',
      telefonoUser: '',
      correo: '',
      idUser: '',
      id_rol: '',
      password : ''
    },
    perPage: 500,
    currentPage: 1,
    fields: [
      { key: 'nombre', label: 'Nombre'},
      { key: 'email', label: 'Correo'},
      { key: 'id_rol', label: 'Rol'},
      { key: 'acciones', label: 'Editar', thClass: 'text-center', tdClass: 'text-center'},
      { key: 'accionInac', label: 'Estado', thClass: 'text-center', tdClass: 'text-center'},
    ],
  }),
  computed:{
    labels(){
      if (this.$store.state._language == "es-ES") {
        return {
          title: "Usuarios",
          subtitle: "Instrucciones",
          instructive: ["Bienvenid@ a la plataforma para la visualización y creación de usuarios"],
          search: "Buscar por Nombre de Usuario",
          information: "Información del Usuario",
          tapLabel: "Datos",
          createdAt: "Fecha Creación",
          name: "Nombre",
          email: "Correo Electrónico",
          informationUser: "Información",
          edit: "Editar",
          inactivate: "Inactivar",
          companyId: "Id de la Compañia",
          phonenumber: "Teléfono de contacto",
          idNumber: "Número de identificación",
          role: "Rol",
          empty: "Aún no cuentas con usuarios",
          create: "Crear",
          active: "Activo",
          inactive: "Inactivo",
          status: "Estado",
          notFoundMessage: "No hay datos con",
          identificationCard: "Cedula",
          phone: "Telefono",
          passw: "Password"
        }
      }else {
        return {
          title: "Users",
          subtitle: "Instructions",
          instructive: ["Welcome to the platform for the visualization and creation of users."],
          search: "Search by User Name",
          information: "Información del Usuario",
          tapLabel: "Datos",
          createdAt: "Created Date",
          name: "User Name",
          email: "Email",
          informationUser: "Information",
          edit: "Edit",
          inactivate: "Inactivate",
          companyId: "Company Id",
          phonenumber: "Contact Number",
          idNumber: "Identification Id",
          role: "Role",
          empty: "You don't have users yet",
          create: "Create",
          active: "Activo",
          inactive: "Inactive",
          status: "Status",
          notFoundMessage: "There is no data with",
          identificationCard: "Identification Card",
          phone: "Phone",
          passw: "Password"
        }
      }
    }
  },
  methods: {
    cierraModal(val){
      this.showInfoUser = val
      this.showDialogEdit = val
      this.inactivateUser = val
    },
    goToCreateUser(){
      this.$router.push({path: '/users/create'})
    },
    showInfo(id) {
      User.getAllUsersById(id)
      .then((res) => {
        // console.log(res.data.exiteUser)
        this.inforUser = res.data.exiteUser
        this.showInfoUser = true
      })
      .catch((err) => {
        console.log(err)
      })
    },
    editUser(id){
      // console.log(id)
      this.showDialogEdit = true
      const currentIdx = this.users.findIndex((obj) => obj.id == id);
      this.dialogItem = this.users[currentIdx];
      this.formEdit.nameUser = this.dialogItem.nombre;
      this.formEdit.cedula = this.dialogItem.cedula;
      // this.formEdit.identificacionUser = this.dialogItem.idNumber;
      // this.formEdit.telefonoUser = this.dialogItem.phone;
      this.formEdit.correo = this.dialogItem.email;
      this.formEdit.phone = this.dialogItem.telefono;
      this.formEdit.id_rol = this.dialogItem.id_rol;
      this.formEdit.idUser = id;
    },
    editaInfoUser(){
      // console.log(this.formEdit)
      this.isLoading = true;
      User.updateUser(this.formEdit)
      .then(() => {
        // console.log(res)
        this.$toast.success("Usuario editado correctamente")
        location. reload()
        this.isLoading = false;
        this.showDialogEdit = false;
      })
      .catch(() =>{
        this.error = true;
      })

    },
    inactivaUser(id){
      // console.log(id)
      this.idUserInactivar = id
      this.inactivateUser = true
    },
    confirmInactivate() {
      if (!this.idUserInactivar) return;

      this.isLoading = true;

      User.inactivarUser(this.idUserInactivar)
      .then((res) => {
        this.$toast.success(res.data.message || "Usuario inactivado correctamente");

        // Actualizar el estado del usuario en la tabla
        const index = this.users.findIndex(u => u.id === this.idUserInactivar);
        if (index !== -1) {
          this.users[index].state = 0; // 0 = inactivo
        }

        this.inactivateUser = false;
      })
      .catch((err) => {
        console.error(err);
        this.$toast.error("No se pudo inactivar el usuario");
      })
      .finally(() => {
        this.isLoading = false;
        this.idUserInactivar = null;
      });
    },
    activarUser(id){
      User.activarUser(id)
      .then((res) => {
        this.$toast.success(res.data.message || "Usuario activado correctamente");

        // Actualizar el estado del usuario en la tabla sin recargar
        const index = this.users.findIndex(u => u.id === id);
        if (index !== -1) {
          this.users[index].state = 1;
        }
      })
      .catch((err) => {
        console.error(err);
        this.$toast.error("No se pudo activar el usuario");
      });
    },
    deleteUser(id) {
      this.isLoading = true;
      User.deleteUser(id).then(() => {
        this.isLoading = false;
      });
      this.users = this.users.filter( user => user.id != id );
    },
    nombreRol(numRol){
      const rol = this.roles.find(r => r.id == numRol);
      return rol ? rol.nombre : '';
    }
  },
  mounted() {
    this.isLoading = true;
    User.getAllUsers(this.$store.state.userName)
    .then((result) => {
      // console.log(result.data)
      this.users = result.data.users;
      if (this.users.length == 0) {
        this.isEmpty = true;
      }
    })
    .catch(() => {
      // console.log(error);
      this.error = true;
    })
    .finally(() => {
      this.isLoading = false;
    });

    Rol.getAllRoles()
    .then((rta) => {
      // console.log(rta.data.roles)
      this.roles = rta.data.roles;
      // this.getOptions(rta.data.roles);
    })
    .catch(() => {
      // console.log(error);
      this.error = true;
    })
  },
};
</script>

<style src="../main.css">
</style>
